import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center zfd-canvas">
        <div className="text-[#FBBF24] font-mono-num text-lg" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !(user.role === "admin" || user.role === "sub_admin")) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
